/**
 * Created for adventure expedition extraction
 * This file serves as the registry/entry point for all adventure expedition content
 */

const AdventureExpedition = {
    LOCATION_IDS: ["adventure", "adventure2", "adventure3", "adventure4", "adventureny", "adventurevd", "patrickday", "earthday", "nightparty", "testadv", "pirates", "laborday26"],

    initialize: function () {
        this.registerMines();
        this.registerConfigs();

        this.sourceAnimations = {};

        this.sourceAnimations.default = {
            advenergy: "bag",
            advrush: "bag",
            exprunes: "bag",
            emeralds: "bag",
            berries: "bag",
            advgift: "chest",
            advreward: "chest",
            advchest: "chest",
            advpile: "chest",
            advfireplace: "chest",
            advrock: "stone",
            advlawn: "wood",
            advsource1: "wood",
            advtree: "wood",
            advbush: "bush",
            advsource0: "bush",
            advflower: "bush",
            advpalmtree: "bush"
        };

        this.LOCATION_IDS.forEach((locationId) => {
            if (AdventureExpedition[`register_${locationId}`]) {
                AdventureExpedition[`register_${locationId}`]();
            }
            if (AdventureExpedition[`register_${locationId}_quests`]) {
                AdventureExpedition[`register_${locationId}_quests`]();
            }
        });

        cleverapps.tutorial.register(AdvStartTutorial());
        cleverapps.tutorial.register(AdvShortTutorial());
        cleverapps.tutorial.register(AdvSpawnerTutorial());
    },

    registerMines: function () {
        if (typeof Mines === "undefined") {
            Mines = {};
        }

        Mines.advsource = Mines.sidequest = Mines.advprize = Mines.runes = function (level, unit) {
            const tasks = Families[unit.code].units[unit.stage].mineable.tasks[level];

            return tasks ? tasks.prizes : undefined;
        };
    },

    registerConfigs: function () {
        this.RESOURCES = {
            advgrass: {
                icon: bundles.resource_icons.frames.resource_advgrass,
                smallIcon: bundles.resource_icons.frames.resource_advgrass_small
            },
            advleaves: {
                icon: bundles.resource_icons.frames.resource_advleaves,
                smallIcon: bundles.resource_icons.frames.resource_advleaves_small
            },
            advlog: {
                icon: bundles.resource_icons.frames.resource_advlog,
                smallIcon: bundles.resource_icons.frames.resource_advlog_small
            },
            advstone: {
                icon: bundles.resource_icons.frames.resource_advstone,
                smallIcon: bundles.resource_icons.frames.resource_advstone_small
            },
            advblueberry: {
                icon: bundles.resource_icons.frames.resource_advblueberry,
                smallIcon: bundles.resource_icons.frames.resource_advblueberry_small
            },
            advlychee: {
                icon: bundles.resource_icons.frames.resource_advlychee,
                smallIcon: bundles.resource_icons.frames.resource_advlychee_small
            },
            advbanana: {
                icon: bundles.resource_icons.frames.resource_advbanana,
                smallIcon: bundles.resource_icons.frames.resource_advbanana_small
            },
            advorange: {
                icon: bundles.resource_icons.frames.resource_advorange,
                smallIcon: bundles.resource_icons.frames.resource_advorange_small
            },
            advcloth: {
                icon: bundles.resource_icons.frames.resource_advcloth,
                smallIcon: bundles.resource_icons.frames.resource_advcloth_small
            },
            advballoon0: {
                icon: bundles.resource_icons.frames.resource_advballoon0,
                smallIcon: bundles.resource_icons.frames.resource_advballoon0_small
            },
            advballoon1: {
                icon: bundles.resource_icons.frames.resource_advballoon1,
                smallIcon: bundles.resource_icons.frames.resource_advballoon1_small
            },
            advballoon2: {
                icon: bundles.resource_icons.frames.resource_advballoon2,
                smallIcon: bundles.resource_icons.frames.resource_advballoon2_small
            },
            advcoctail: {
                icon: bundles.resource_icons.frames.resource_advcoctail,
                smallIcon: bundles.resource_icons.frames.resource_advcoctail_small
            },
            advtea: {
                icon: bundles.resource_icons.frames.resource_advtea,
                smallIcon: bundles.resource_icons.frames.resource_advtea_small
            },
            advicecream: {
                icon: bundles.resource_icons.frames.resource_advicecream,
                smallIcon: bundles.resource_icons.frames.resource_advicecream_small
            },
            advcake: {
                icon: bundles.resource_icons.frames.resource_advcake,
                smallIcon: bundles.resource_icons.frames.resource_advcake_small
            },
            exprunes: {}
        };

        this.SPAWNER_PRIZES = [
            { code: "advrock", stage: 0, weight: 2 },
            { code: "advlawn", stage: 1 },
            { code: "advlawn", stage: 2 },
            { code: "advbush", stage: 4 },
            { code: "advbush", stage: 6 },
            { code: "advbush", stage: 8 },
            { code: "advflower", stage: 0 },
            { code: "advflower", stage: 1 },
            { code: "advflower", stage: 2 },
            { code: "advpalmtree", stage: 0 },
            { code: "advpalmtree", stage: 2 },
            { code: "advpalmtree", stage: 5 },
            { code: "advtree", stage: 2 }
        ];

        this.WAREHOUSE_TUTORIAL_MINIMAL = [
            {
                x: { align: "center", dx: 0 },
                y: { align: "center", dy: 130 }
            },
            {
                x: { align: "center", dx: 0 },
                y: { align: "center", dy: 130 }
            },
            {
                x: { align: "center", dx: 0 },
                y: { align: "center", dy: 130 }
            }
        ];

        this.TILE_MATERIALS = {
            "30_21": "wood",
            "31_21": "wood",
            "30_22": "wood",
            "31_22": "wood",
            "60_33": "stone",
            "61_33": "stone",
            "60_34": "stone",
            "61_34": "stone",
            "25_43": "stone",
            "26_43": "stone",
            "25_44": "stone",
            "26_44": "stone",
            "28_61": "stone",
            "29_61": "stone",
            "28_62": "stone",
            "29_62": "stone",
            "51_67": "stone",
            "52_67": "stone",
            "51_68": "stone",
            "52_68": "stone"
        };

        this.DONORS = [
            "adv3rpcustomerbridge0",
            "adv3rpcustomermain0",
            "adv3rpcustomerbridge1",
            "adv3rpcustomermain1",
            "adv3rpcustomerbridge2",
            "adv3rpcustomermain2",
            "adv3rpcustomerbridge3",
            "adv3rpcustomermain3",
            "adv3rpcustomerbridge4",
            "adv3rpcustomermain4"
        ];

        this.CUSTOMER_RECIPES = this.createCustomerRecipes();
    },

    createProducerRecipe: function (duration, targetCode, productAmount, fog, ing1, amt1, ing2, amt2, productCode, stage) {
        return {
            cookingDuration: duration,
            targetUnits: [{ code: targetCode, stage: 0 }],
            productAmount,
            fog,
            ingredients: [{ ingredient: ing1, amount: amt1 }, { ingredient: ing2, amount: amt2 }],
            order: [{ code: productCode, stage: stage === undefined ? 0 : stage, amount: 1 }]
        };
    },

    createCustomerRecipes: function () {
        return {
            adv3rpcustomerbridge0_0: [{
                cookingDuration: "3 minutes",
                ingredients: [{ ingredient: "advgrass", amount: 5 }, { ingredient: "advleaves", amount: 5 }]
            }],
            adv3rpcustomerbridge1_0: [{
                cookingDuration: "5 minutes",
                ingredients: [{
                    code: "adv3rpproduct0", stage: 0, amount: 2, customInfo: { disablePurchase: true } 
                }]
            }],
            adv3rpcustomerbridge2_0: [{
                cookingDuration: "12 minutes",
                ingredients: [{
                    code: "adv3rpproduct1", stage: 0, amount: 3, customInfo: { disablePurchase: true } 
                }]
            }],
            adv3rpcustomerbridge3_0: [{
                cookingDuration: "6 minutes",
                ingredients: [{
                    code: "adv3rpproduct2", stage: 0, amount: 4, customInfo: { disablePurchase: true } 
                }]
            }],
            adv3rpcustomerbridge4_0: [{
                cookingDuration: "14 minutes",
                ingredients: [{
                    code: "adv3rpproduct3", stage: 0, amount: 5, customInfo: { disablePurchase: true } 
                }]
            }],
            adv3rpcustomermain0_0: [{
                cookingDuration: "5 minutes",
                ingredients: [{
                    code: "adv3rpproduct0", stage: 0, amount: 2, customInfo: { disablePurchase: true } 
                }]
            }],
            adv3rpcustomermain1_0: [{
                cookingDuration: "15 minutes",
                ingredients: [{
                    code: "adv3rpproduct1", stage: 0, amount: 3, customInfo: { disablePurchase: true } 
                }]
            }],
            adv3rpcustomermain2_0: [{
                cookingDuration: "1 minutes",
                ingredients: [{
                    code: "adv3rpproduct2", stage: 0, amount: 4, customInfo: { disablePurchase: true } 
                }]
            }],
            adv3rpcustomermain3_0: [{
                cookingDuration: "4 minutes",
                ingredients: [{
                    code: "adv3rpproduct3", stage: 0, amount: 5, customInfo: { disablePurchase: true } 
                }]
            }],
            adv3rpcustomermain4_0: [{
                cookingDuration: "12 minutes",
                ingredients: [{
                    code: "adv3rpproduct4", stage: 0, amount: 4, customInfo: { disablePurchase: true } 
                }]
            }],
            adv3rpproducer0_0: [
                this.createProducerRecipe("15 minutes", "adv3rpcustomermain0", 0, "fog1", "advlychee", 15, "advblueberry", 15, "adv3rpproduct0"),
                this.createProducerRecipe("11 minutes", "adv3rpcustomermain0", 1, "fog1", "advleaves", 10, "advlog", 10, "adv3rpproduct0"),
                this.createProducerRecipe("3 minutes", "adv3rpcustomerbridge1", 0, "fog2", "advstone", 15, "advgrass", 15, "adv3rpproduct0"),
                this.createProducerRecipe("10 minutes", "adv3rpcustomerbridge1", 1, "fog2", "advbanana", 15, "advleaves", 20, "adv3rpproduct0")
            ],
            adv3rpproducer1_0: [
                this.createProducerRecipe("1 minutes", "adv3rpcustomermain1", 0, "fog3", "advleaves", 25, "advgrass", 30, "adv3rpproduct1"),
                this.createProducerRecipe("5 minutes", "adv3rpcustomermain1", 1, "fog3", "advlog", 25, "advleaves", 20, "adv3rpproduct1"),
                this.createProducerRecipe("15 minutes", "adv3rpcustomermain1", 2, "fog3", "advlychee", 20, "advlog", 20, "adv3rpproduct1"),
                this.createProducerRecipe("2 minutes", "adv3rpcustomerbridge2", 0, "fog4", "advleaves", 20, "advbanana", 20, "adv3rpproduct1"),
                this.createProducerRecipe("7 minutes", "adv3rpcustomerbridge2", 1, "fog4", "advstone", 15, "advlog", 25, "adv3rpproduct1"),
                this.createProducerRecipe("10 minutes", "adv3rpcustomerbridge2", 2, "fog4", "advleaves", 25, "advlog", 25, "adv3rpproduct1")
            ],
            adv3rpproducer2_0: [
                this.createProducerRecipe("14 minutes", "adv3rpcustomermain2", 0, "fog5", "advlychee", 30, "advbanana", 30, "adv3rpproduct2"),
                this.createProducerRecipe("8 minutes", "adv3rpcustomermain2", 1, "fog5", "advleaves", 35, "advlog", 30, "adv3rpproduct2"),
                this.createProducerRecipe("2 minutes", "adv3rpcustomermain2", 2, "fog5", "advblueberry", 30, "advgrass", 35, "adv3rpproduct2"),
                this.createProducerRecipe("6 minutes", "adv3rpcustomermain2", 3, "fog5", "advbanana", 30, "advlog", 40, "adv3rpproduct2"),
                this.createProducerRecipe("8 minutes", "adv3rpcustomerbridge3", 0, "fog6", "advleaves", 45, "advlog", 40, "adv3rpproduct2"),
                this.createProducerRecipe("15 minutes", "adv3rpcustomerbridge3", 1, "fog6", "advblueberry", 40, "advlychee", 35, "adv3rpproduct2"),
                this.createProducerRecipe("5 minutes", "adv3rpcustomerbridge3", 2, "fog6", "advstone", 45, "advleaves", 50, "adv3rpproduct2"),
                this.createProducerRecipe("12 minutes", "adv3rpcustomerbridge3", 3, "fog6", "advleaves", 50, "advgrass", 50, "adv3rpproduct2")
            ],
            adv3rpproducer3_0: [
                this.createProducerRecipe("9 minutes", "adv3rpcustomermain3", 0, "fog7", "advbanana", 50, "advblueberry", 50, "adv3rpproduct3"),
                this.createProducerRecipe("11 minutes", "adv3rpcustomermain3", 1, "fog7", "advleaves", 40, "advlog", 40, "adv3rpproduct3"),
                this.createProducerRecipe("14 minutes", "adv3rpcustomermain3", 2, "fog7", "advgrass", 50, "advleaves", 50, "adv3rpproduct3"),
                this.createProducerRecipe("10 minutes", "adv3rpcustomermain3", 3, "fog7", "advleaves", 40, "advlog", 40, "adv3rpproduct3"),
                this.createProducerRecipe("5 minutes", "adv3rpcustomermain3", 4, "fog7", "advbanana", 35, "advlog", 40, "adv3rpproduct3"),
                this.createProducerRecipe("6 minutes", "adv3rpcustomerbridge4", 0, "fog8", "advgrass", 40, "advleaves", 40, "adv3rpproduct3"),
                this.createProducerRecipe("11 minutes", "adv3rpcustomerbridge4", 1, "fog8", "advlog", 40, "advstone", 45, "adv3rpproduct3"),
                this.createProducerRecipe("9 minutes", "adv3rpcustomerbridge4", 2, "fog8", "advlychee", 50, "advlog", 40, "adv3rpproduct3"),
                this.createProducerRecipe("8 minutes", "adv3rpcustomerbridge4", 3, "fog8", "advblueberry", 45, "advbanana", 40, "adv3rpproduct3"),
                this.createProducerRecipe("11 minutes", "adv3rpcustomerbridge4", 4, "fog8", "advgrass", 40, "advleaves", 40, "adv3rpproduct3")
            ],
            adv3rpproducer4_0: [
                this.createProducerRecipe("2 minutes", "adv3rpcustomermain4", 0, "fog9", "advlychee", 40, "advbanana", 25, "adv3rpproduct4"),
                this.createProducerRecipe("5 minutes", "adv3rpcustomermain4", 1, "fog9", "advgrass", 50, "advleaves", 50, "adv3rpproduct4"),
                this.createProducerRecipe("12 minutes", "adv3rpcustomermain4", 2, "fog9", "advleaves", 35, "advlog", 50, "adv3rpproduct4"),
                this.createProducerRecipe("7 minutes", "adv3rpcustomermain4", 3, "fog9", "advstone", 25, "advblueberry", 35, "adv3rpproduct4")
            ]
        };
    },

    createExtendedHarvestedConfig: function () {
        return {
            capacity: 8080,
            price: 250,
            hideCapacity: true,
            resources: this.RESOURCES
        };
    },

    createQuestsConfig: function (locationId, options) {
        options = options || {};

        QuestsConfig[locationId] = cleverapps.clone(QuestsConfig.universal, true);

        delete QuestsConfig[locationId].rpcustomerbridge0_0;
        delete QuestsConfig[locationId].rpcustomermain0_0;
        delete QuestsConfig[locationId].rpcustomermain1_0;
        delete QuestsConfig[locationId].rpcustomermain2_0;
        if (options.deleteRpcustomermain3_0) {
            delete QuestsConfig[locationId].rpcustomermain3_0;
        }
        delete QuestsConfig[locationId].rpcustomermain4_0;

        if (options.adv4pack) {
            QuestsConfig[locationId].exprunes = {
                priority: 1,
                trigger: { fog: "fog1" },
                dynamic: {
                    getIcon: function () {
                        return UnitView.getUnitImage({ code: "exprunes", stage: 0 }, { alignAnchorX: true });
                    },
                    getTitle: function () {
                        return Messages.get("Quest.exprunes.title");
                    },
                    rowCtor: StagesQuestRow,
                    getGoal: function (quest) {
                        return (1 << quest.goal) - 1;
                    },
                    addProgress: function (quest, options) {
                        const unit = options.unit || options.affected;
                        quest.progress |= (1 << unit.stage);
                    }
                },
                quest: {
                    type: Map2d.MINE,
                    unit: { code: "exprunes" }
                }
            };

            QuestsConfig[locationId].energychests = {
                priority: 1,
                trigger: { unit: { code: "advrush", stage: 5 } },
                dynamic: {
                    rowCtor: ProgressQuestRow
                },
                quest: {
                    type: Map2d.PRIZE_HARVESTED,
                    unit: { code: "advrush", stage: 5 },
                    toMainWorld: true
                }
            };

            QuestsConfig[locationId].resourcebaskets = {
                priority: 1,
                trigger: { unit: { code: "advpile", stage: 4 } },
                dynamic: {
                    rowCtor: ProgressQuestRow
                },
                quest: {
                    type: Map2d.PRIZE_HARVESTED,
                    unit: { code: "advpile", stage: 4 },
                    toMainWorld: true
                }
            };

            QuestsConfig[locationId].emeralds = {
                priority: 1,
                trigger: { fog: "fog2" },
                dynamic: {
                    rowCtor: ProgressQuestRow,
                    getIcon: function () {
                        return UnitView.getUnitImage({ code: "emeralds", stage: 0 }, { alignAnchorX: true });
                    }
                },
                quest: {
                    type: Map2d.MINE,
                    unit: { code: "emeralds" },
                    toMainWorld: true
                }
            };

            QuestsConfig[locationId].berries = {
                priority: 1,
                trigger: { fog: "fog2" },
                dynamic: {
                    rowCtor: ProgressQuestRow,
                    getIcon: function () {
                        return UnitView.getUnitImage({ code: "berries", stage: 1 }, { alignAnchorX: true });
                    },
                    addProgress: function (quest, options) {
                        const unit = options.unit || options.affected;
                        if (unit.stage === 0) {
                            quest.progress += 3;
                        } else {
                            quest.progress += 1;
                        }
                    }
                },
                quest: {
                    type: Map2d.MINE,
                    unit: { code: "berries" },
                    toMainWorld: true
                }
            };
        }

        cleverapps.override(QuestsConfig[locationId], {
            rpproducer3: {
                trigger: {
                    fog: undefined,
                    unit: { code: "rpcustomermain3", stage: 0 }
                },
                quest: {
                    type: Map2d.OPEN_UNIT,
                    unit: { code: "rpproducer3", stage: 0 }
                }
            },
            rpproducer4: {
                trigger: {
                    fog: "fog0",
                    unit: undefined
                },
                quest: {
                    type: Map2d.OPEN_UNIT,
                    unit: { code: "rpproducer4", stage: 0 }
                },
                findOnStart: options.findOnStart,
                tutorial: "AdvStartTutorial",
                lockMapDuringStartQuest: true
            },
            rpcustomerbridge1_1: {
                trigger: {
                    fog: undefined,
                    unit: { code: "rpcustomerbridge1", stage: 0 }
                }
            },
            rpproducer1: {
                trigger: { unit: { code: "rpcustomermain1", stage: 0 } }
            },
            rpcustomermain1_1: {
                trigger: { unit: { code: "rpcustomermain1", stage: 0 } }
            }
        });

        Object.keys(QuestsConfig[locationId]).forEach((key) => {
            const value = QuestsConfig[locationId][key];

            delete QuestsConfig[locationId][key];
            QuestsConfig[locationId][key.indexOf("rp") === 0 ? `adv3${key}` : key] = value;

            ["quest", "trigger"].forEach((item) => {
                if (value[item] && value[item].unit && value[item].unit.code.indexOf("rp") === 0) {
                    value[item].unit.code = `adv3${value[item].unit.code}`;
                }
            });
        });
    }
};

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    ADVENTURE_CUSTOMER_INGREDIENT_INFOVIEW: {
        size: 36,
        stroke: {
            size: 2,
            color: new cc.Color(44, 64, 90, 255)
        },
        shadow: {
            color: new cc.Color(67, 69, 74, 128),
            direction: cc.size(1, -4),
            blur: 0
        },
        color: cleverapps.styles.COLORS.WHITE
    }
});